module.exports = __webpack_public_path__ + "static/media/Toronto_Maple_Leafs.2d645b2e.svg";